(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveals al hacer scroll (un solo observer compartido)
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveals(root) {
    root.querySelectorAll('.mt-reveal, .mt-min-anillo, .mt-caja-escena').forEach(function (el) {
      if (el.dataset.mtObs) return;
      el.dataset.mtObs = '1';
      if (!io || reduce) { el.classList.add('mt-visible'); return; }
      io.observe(el);
    });
  }

  // Héroe spotlight: el foco sigue suavemente al cursor
  function initHero(root) {
    root.querySelectorAll('.mt-hero[data-foco="true"]').forEach(function (hero) {
      if (hero.dataset.mtInit) return;
      hero.dataset.mtInit = '1';
      var foco = hero.querySelector('.mt-hero-foco');
      if (!foco || reduce || window.matchMedia('(hover: none)').matches) return;
      var tx = 72, ty = 50, cx = 72, cy = 50, raf = null;
      function loop() {
        cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
        foco.style.setProperty('--mt-fx', cx + '%');
        foco.style.setProperty('--mt-fy', cy + '%');
        raf = (Math.abs(tx - cx) > 0.1 || Math.abs(ty - cy) > 0.1) ? requestAnimationFrame(loop) : null;
      }
      hero.addEventListener('pointermove', function (ev) {
        var r = hero.getBoundingClientRect();
        tx = ((ev.clientX - r.left) / r.width) * 100;
        ty = ((ev.clientY - r.top) / r.height) * 100;
        if (!raf) raf = requestAnimationFrame(loop);
      });
    });
  }

  // Hotspots
  function initHotspots(root) {
    root.querySelectorAll('.mt-hs-escena').forEach(function (esc) {
      if (esc.dataset.mtInit) return;
      esc.dataset.mtInit = '1';
      var puntos = esc.querySelectorAll('.mt-hs-punto');
      var seccion = esc.closest('.mt-section');
      function abrir(idx) {
        puntos.forEach(function (p, i) {
          var t = esc.querySelector('#' + p.getAttribute('aria-controls'));
          var on = i === idx;
          p.setAttribute('aria-expanded', on ? 'true' : 'false');
          if (t) t.classList.toggle('mt-abierta', on);
        });
        if (seccion) seccion.querySelectorAll('.mt-hs-item').forEach(function (it, i) { it.classList.toggle('mt-activo', i === idx); });
      }
      puntos.forEach(function (p, i) {
        p.addEventListener('click', function () { abrir(p.getAttribute('aria-expanded') === 'true' ? -1 : i); });
        p.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) abrir(i); });
      });
      esc.addEventListener('mouseleave', function () { if (window.matchMedia('(hover: hover)').matches) abrir(-1); });
    });
  }

  // Selector de escenario
  function initEscenarios(root) {
    root.querySelectorAll('.mt-esc').forEach(function (bloque) {
      if (bloque.dataset.mtInit) return;
      bloque.dataset.mtInit = '1';
      var btns = bloque.querySelectorAll('.mt-esc-btn');
      var paneles = bloque.querySelectorAll('.mt-esc-panel');
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () {
          btns.forEach(function (x, j) { x.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
          paneles.forEach(function (p, j) { p.classList.toggle('mt-activo', i === j); });
        });
      });
    });
  }

  // Carrusel de opiniones: flechas + avance automático (pausa al pasar el ratón o tocar)
  function initOpiniones(root) {
    root.querySelectorAll('.mt-op').forEach(function (op) {
      if (op.dataset.mtInit) return;
      op.dataset.mtInit = '1';
      var pista = op.querySelector('.mt-op-pista');
      if (!pista) return;
      function paso() { var t = pista.querySelector('.mt-op-tarjeta'); return t ? t.getBoundingClientRect().width + 20 : 300; }
      function mover(dir) {
        var fin = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 4;
        if (dir > 0 && fin) pista.scrollTo({ left: 0 }); else pista.scrollBy({ left: dir * paso() });
      }
      op.querySelectorAll('.mt-op-flecha').forEach(function (b) { b.addEventListener('click', function () { mover(+b.dataset.dir); }); });
      if (op.dataset.auto === 'true' && !reduce) {
        var parado = false;
        ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) { op.addEventListener(ev, function () { parado = true; }, { passive: true }); });
        op.addEventListener('mouseleave', function () { parado = false; });
        setInterval(function () { if (!parado && !document.hidden) mover(1); }, (+op.dataset.vel || 5) * 1000);
      }
    });
  }

  // FAQ
  function initFaq(root) {
    root.querySelectorAll('.mt-faq-item').forEach(function (item) {
      if (item.dataset.mtInit) return;
      item.dataset.mtInit = '1';
      var btn = item.querySelector('.mt-faq-pregunta');
      btn.addEventListener('click', function () {
        var abierto = item.classList.toggle('mt-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  // Página de producto: galería, variantes y barra fija
  function initProducto(root) {
    root.querySelectorAll('.mt-prod').forEach(function (prod) {
      if (prod.dataset.mtInit) return;
      prod.dataset.mtInit = '1';
      var principal = prod.querySelector('.mt-prod-principal img');
      prod.querySelectorAll('.mt-prod-mini').forEach(function (m) {
        m.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = 0;
          setTimeout(function () { principal.src = m.dataset.src; principal.style.opacity = 1; }, 180);
          prod.querySelectorAll('.mt-prod-mini').forEach(function (x) { x.setAttribute('aria-current', x === m ? 'true' : 'false'); });
        });
      });

      var datos = prod.querySelector('[data-mt-variantes]');
      var selects = prod.querySelectorAll('.mt-prod-opcion select');
      if (datos && selects.length) {
        var variantes = JSON.parse(datos.textContent);
        var input = prod.querySelector('input[name="id"]');
        var precio = prod.querySelectorAll('[data-mt-precio]');
        var tachado = prod.querySelectorAll('[data-mt-tachado]');
        var boton = prod.querySelectorAll('[data-mt-boton]');
        var fmt = prod.dataset.moneda || '$';
        function dinero(c) { return fmt + (c / 100).toFixed(2); }
        function actualizar() {
          var vals = Array.prototype.map.call(selects, function (s) { return s.value; });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
          if (!v) return;
          input.value = v.id;
          precio.forEach(function (p) { p.textContent = dinero(v.price); });
          tachado.forEach(function (t) { t.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; });
          boton.forEach(function (b) {
            b.disabled = !v.available;
            b.textContent = v.available ? b.dataset.texto : b.dataset.agotado;
          });
        }
        selects.forEach(function (s) { s.addEventListener('change', actualizar); });
      }

      var barra = prod.querySelector('.mt-prod-barra');
      var form = prod.querySelector('.mt-prod-form');
      if (barra && form && io) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { barra.classList.toggle('mt-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(form);
        var bb = barra.querySelector('button');
        if (bb) bb.addEventListener('click', function () { var b = form.querySelector('button[type="submit"]'); if (b) b.click(); });
      }
    });
  }

  function initTodo(ev) {
    var root = (ev && ev.target && ev.target.querySelectorAll) ? ev.target : document;
    initReveals(root); initHero(root); initHotspots(root); initEscenarios(root); initOpiniones(root); initFaq(root); initProducto(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
